import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Table from '../components/table/main';

import { selectors as rootSelectors } from '../../root';
const Main = renderViewsState(
	props =>
		<Animate>
			<div className="container__content discounts-list">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Bonuses & Discounts')}</h1>
					</div>
				</div>
				<div className="container__content-body">

					<div className="ui-control-bar">
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<Link
									to='discounts/new'
									className='ui-btn ui-btn-primary add-discount__button ui-btn-sign__plus'
								>
									Create partner discount
								</Link>
							</div>
						</div>
					</div>

					<div className="discounts-list__table-position">
						<Table {...props} />
					</div>
				</div>
			</div>
		</Animate>,
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		query: selectors.getQuery(state),
		table: selectors.getTable(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		can: selectors.getCan(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/discounts/list/main.js